var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating5GrayOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.155 1.2063H1.15503V61.2063H61.155V1.2063Z",
    stroke: "#797979",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.238 34.688C46.238 36.3454 45.9065 38.0029 45.4093 39.4946C43.4203 45.4615 37.785 49.7709 31.1551 49.7709C24.5253 49.7709 18.8899 45.4615 16.901 39.4946C16.4038 38.0029 16.0723 36.3454 16.0723 34.688H46.238Z",
    fill: "#797979",
    stroke: "#797979",
    strokeWidth: 5.6693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1655 10.2037C29.3313 12.8557 28.3368 18.1595 21.5412 24.1264C12.5909 22.9662 8.94451 18.9883 7.61854 16.6678C7.12131 15.8391 6.95557 15.3419 6.95557 15.1761C6.12684 12.1927 7.7843 8.87778 10.7677 8.04905C13.7512 7.22032 17.0661 8.87778 17.8948 11.8612C17.0661 8.87778 18.7235 5.56286 21.7069 4.73413C24.6904 3.9054 28.0053 5.56286 28.834 8.54629C28.9998 8.54629 29.1655 9.20927 29.1655 10.2037Z",
    fill: "#797979"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1435 10.2037C32.9778 12.8557 33.9723 18.1595 40.7678 24.1264C49.7181 22.9662 53.3645 18.9883 54.6905 16.6678C55.1878 15.8391 55.3535 15.3419 55.3535 15.1761C56.1822 12.1927 54.5248 8.87778 51.5413 8.04905C48.5579 7.22032 45.243 8.87778 44.4143 11.8612C45.243 8.87778 43.5855 5.56286 40.6021 4.73413C37.6187 3.9054 34.3038 5.56286 33.475 8.54629C33.3093 8.54629 33.1435 9.20927 33.1435 10.2037Z",
    fill: "#797979"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.238 34.688C46.238 36.3454 45.9065 38.0029 45.4093 39.4946H16.901C16.4038 38.0029 16.0723 36.3454 16.0723 34.688H46.238Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating5GrayOutlined);
export default __webpack_public_path__ + "static/media/rating5-gray-outlined.d8ff058f723fae06745a3d1b679b77bd.svg";
export { ForwardRef as ReactComponent };